import Config from "./Config";
import Utils from "./Utils";

class IntegrationService {
    constructor() {
        if (Config.APP_ENV !== "production") {
            console.log(
                "IntegrationService initialized in non-production environment. Skipping integrations."
            );
            return;
        }

        this.initBH();
    }

    // BugHerd Initialization
    initBH = () => {
        if (!Config.BUGHERD_API_KEY) return;

        Utils.LoadScript(
            `https://www.bugherd.com/sidebarv2.js?apikey=${Config.BUGHERD_API_KEY}`
        ).catch((e) => console.error("Error loading BugHerd script:", e));
    };
}

export default IntegrationService;
